import React from 'react';
import {ProblemStarRating} from '@types';
import {MODAL_PROBLEM_STARS, showModal} from '@utils';
import {useTranslation} from 'react-i18next';

export const StarContent = ({starRating}: {starRating: ProblemStarRating}) => {
    const {t} = useTranslation();

    return starRating.votes > 0 ? (
        <span>
            {`${starRating.stars} (`}
            <span
                className="link"
                onClick={() => {
                    showModal(MODAL_PROBLEM_STARS);
                }}>
                {t('common.votes', {count: starRating.votes})}
            </span>
            {')'}
        </span>
    ) : null;
};
